import Vue from 'vue'

const ENDPOINT = '/function_titles'

export default {
  create (params) {
    return Vue.prototype.$http.post(`${ENDPOINT}`, { function_title: params }).then(response => response.data)
  }
}
